export default __webpack_public_path__ + "static/pawel_zielinski-094d75b199381d606945e70dad8adf9c.jpeg";